<template>
  <div class="w-card">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name : `wCard`,
  };
</script>

<style lang="scss">
  .w-card {
    border: 1px solid #E2E3E6;
    border-radius: 5px;
    padding: 10px;
    background-color: #FFF;
  }
</style>



// WEBPACK FOOTER //
// WCard.vue?eea883c0